<template>
  <div class="serviceSelect">
    <h4 class="col-md-2 serviceSelect__title">篩選服務:</h4>
    <el-row>
      <el-col :span="24">
        <el-tag
          @click="selectService(tag, index)"
          class="serviceSelect__tag"
          :key="tag.name"
          v-for="(tag, index) in filterServiceName"
          size="large"
          :effect="tag.effect"
          :disable-transitions="false"
        >
          {{ tag.name }}
        </el-tag>
      </el-col>
    </el-row>
    <div class="col-md-3" style="padding-left: 0px">
      <select
        id="service-select"
        class="form-control fontSize16"
        v-model="filter"
        @change="changeServiceList(filter)"
      >
        <option disabled :value="-1">請選擇服務</option>
        <option
          v-for="service in serviceList"
          :value="service"
          :class="service.class"
        >
          {{ service.item }}
        </option>
      </select>
    </div>
    <BaseButton
      class="serviceSelect__button"
      :text="'清除'"
      :backgroundColor="'#394D5F'"
      :textColor="'#FFF'"
      @click="setClearFiliter"
    />
  </div>
</template>
<script>
import { reqServiceList } from '@/api/hail'
import BaseButton from '@/components/common/button/BaseButton'
import BehaviorRecorder from '../../assets/js/libs/BehaviorRecorder'
import Customer from '@/assets/js/libs/Customer.js'
import Cookies from 'js-cookie'
const customer = new Customer()
export default {
  props: ['serviceIdList', 'serviceNameList', 'customerPhone'],
  data() {
    return {
      serviceList: [],
      historyList: [], // 歷史服務 tag 列表
      filter: -1,
      selectServiceList: [],
      selectServiceNameList: [],
      displayTagList: [], // 顯示用的 tag 陣列
    }
  },
  async mounted() {
    try {
      const { result } = await reqServiceList()
      this.serviceList = result.serviceList.map(({ id, name }) => {
        return {
          value: id,
          item: name,
        }
      })
      this.initHistoryList() // 初始化 historyList 與 displayTagList
    } catch (e) {
      console.error(e)
    }
  },
  watch: {
    serviceIdList: {
      handler() {
        this.initHistoryList()
      },
      immediate: true,
      deep: true,
    },
    serviceList: {
      handler() {
        this.initHistoryList()
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 初始化 displayTagList，僅根據 historyList 設定
    initHistoryList() {
      this.historyList = this.serviceList
        .filter((service) => this.serviceIdList.includes(service.value))
        .map((service) => ({
          name: service.item,
          id: service.value,
          effect: 'plain', // 預設為未選取
        }))
      // 初始化 displayTagList 為 historyList 的複製
      this.displayTagList = this.historyList.map((item) => ({ ...item }))
      // selectServiceList/selectServiceNameList 只包含已選取的服務（effect 為 'dark'）
      this.selectServiceList = this.historyList
        .filter((item) => item.effect === 'dark')
        .map((item) => item.id)
      this.selectServiceNameList = this.historyList
        .filter((item) => item.effect === 'dark')
        .map((item) => item.name)
    },
    selectService(val, index) {
      // 點擊 tag 只切換狀態，不會消失
      if (val.effect === 'dark') {
        this.displayTagList[index].effect = 'plain'
        // 只移除 selectServiceList/selectServiceNameList 的 id/name，不移除 tag
        const idx = this.selectServiceList.indexOf(val.id)
        if (idx !== -1) {
          this.selectServiceList.splice(idx, 1)
          this.selectServiceNameList.splice(idx, 1)
        }
      } else {
        this.displayTagList[index].effect = 'dark'
        if (this.selectServiceList.indexOf(val.id) === -1) {
          this.selectServiceList.push(val.id)
          this.selectServiceNameList.push(val.name)
        }
      }
      this.$emit('serviceListChange', this.getServiceListString())
      this.$emit('service-chinese', this.selectServiceNameList.toString())
    },
    changeServiceList(filter) {
      // 下拉選單選取服務時，若不在 displayTagList，則新增
      const idx = this.displayTagList.findIndex(
        (item) => item.id === filter.value,
      )
      if (idx === -1) {
        this.displayTagList.push({
          name: filter.item,
          id: filter.value,
          effect: 'dark',
        })
        this.selectServiceList.push(filter.value)
        this.selectServiceNameList.push(filter.item)
      } else {
        // 已存在，若未選取則切換為已選取
        if (this.displayTagList[idx].effect !== 'dark') {
          this.displayTagList[idx].effect = 'dark'
          if (this.selectServiceList.indexOf(filter.value) === -1) {
            this.selectServiceList.push(filter.value)
            this.selectServiceNameList.push(filter.item)
          }
        }
      }
      this.$emit('serviceListChange', this.getServiceListString())
      this.$emit('service-chinese', this.selectServiceNameList.toString())
    },
    setClearFiliter() {
      // 只有按鈕點擊才會呼叫這個方法，這裡加上行為記錄
      BehaviorRecorder.record(
        '點擊',
        '派車頁面',
        `進線電話:(${this.customerPhone})，點擊清除(篩選服務)`,
      )
      this.clearService()
    },
    async clearService() {
      if (this.historyList.length === 0) {
        // 若 historyList 為空，也要清空畫面上的 tag
        this.clearFilterOnly()
        return
      }
      // historyList是obj要取出id弄成array
      const serviceIds = this.historyList.map((item) => item.id)
      const result = await customer.clearService({
        phone: this.customerPhone,
        serviceIds: serviceIds,
        teamCode: Cookies.get('GladTeamCode'),
      })
      if (result.success) {
        this.$msg(result.message)
        this.clearFilterOnly()
      } else {
        this.$msg(result.message)
      }
    },
    clearFilterOnly() {
      // 純清除，不記錄
      this.historyList = []
      this.displayTagList = []
      this.selectServiceList = []
      this.selectServiceNameList = []
      this.filter = -1
      this.$emit('serviceListChange', null)
    },
    getServiceList() {
      return this.selectServiceList
    },
    getHistoryServiceList() {
      return this.historyList
    },
    getServiceListString() {
      return this.selectServiceList.toString()
    },
  },
  computed: {
    filterServiceName() {
      // 回傳顯示用的 tag 陣列
      return this.displayTagList
    },
  },
  components: {
    BaseButton,
  },
}
</script>
<style lang="scss" scoped>
.serviceSelect {
  &__title {
    font-size: 18px;
    color: black;
    margin: 0;
    margin-left: 15px;
    height: 36px;
    line-height: 36px;
  }

  &__inputField {
    height: 36px;
    padding: 6px 12px;
    font-size: 16px;
    color: #555;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  &__button {
    width: 65px;
    height: 36px;
    margin: 0;
    margin-left: 10px;
    outline: none;
  }
  &__tag {
    margin-right: 8px;
    margin-top: 8px;
    margin-bottom: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hailing/ServiceSelect.vue